<template>
  <div>
    <div @click="openUser" :class="['user', mini ? 'user_mini': '']">

      <div class="user__left left-panel">
        <div class="left-panel__main-data user-data">
          <div class="user-data__photo">
            <letters-avatar :name="user.name" type="mini"/>
          </div>
          <div class="user-data__info info-user">
            <div class="info-user__name">{{ user.name }} <span class="info-user__id">ID: {{ user.id }}</span></div>
            <div class="info-user__phone">{{ user.phone }}</div>
          </div>
        </div>

        <div class="right-panel__last-activity last-time">
          <div class="last-time__title">Последнее посещение:</div>
          <div v-if="user.last_screening" class="last-time__date">
            {{ $root.dateDefault(user.last_screening) }}
            <span class="last-time__date_time">
              <time-icon/>
              {{ $root.timeIso(user.last_screening) }}
            </span>
          </div>
          <div v-else class="last-time__date">-</div>
        </div>
      </div>

      <div class="right-panel" v-if="!mini">
        <div class="right-panel__item last-time">
          <div class="last-time__title">Последняя активность:</div>
          <div v-if="user.last_activity" class="last-time__date">
            {{ $root.dateDefault(user.last_activity) }}
            <span class="last-time__date_time">
              <time-icon/>
              {{ $root.timeIso(user.last_activity) }}
            </span>
          </div>
          <div v-else class="last-time__date">-</div>
        </div>

        <div class="right-panel__item sing">
          <el-tooltip v-if="user.check_appointment" content="Необходима валидация" placement="top">
            <attention-icon/>
          </el-tooltip>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import LettersAvatar from "@/components/elements/LettersAvatar";
import TimeIcon from "@/components/icons/Time";
import AttentionIcon from "@/components/icons/Attention";

export default {
  name: "UserListItem",
  components: {LettersAvatar, TimeIcon, AttentionIcon},
  props: {
    user: {},
    history: {
      type: Boolean
    },
    mini: {
      type: Boolean
    }
  },
  data: () => {
    return {};
  },
  computed: {},
  methods: {
    openUser() {
      this.$emit("openUser", this.user);
    },


  },
};
</script>

<style scoped lang="scss">
.user {
  margin-bottom: 12px;
  padding: 10px 16px;

  background: #fff;
  border-radius: 6px;

  align-self: flex-start;
  display: flex;
  justify-content: space-between;

  transition: all 0.3s ease;
  cursor: pointer;
  align-items: center;
  color: #8c8c8c;

  &:hover {
    box-shadow: 0 2px 4px rgba(55, 71, 79, 0.16),
    0 4px 8px rgba(55, 71, 79, 0.08);
  }

  &_mini {
    background: #EFEFF4;
  }

}

.left-panel {
  display: flex;
  justify-content: space-between;
  align-items: center;

  &__main-data {
    padding-right: 10px;
  }

  .user-data {
    display: flex;
    justify-content: space-between;
    align-items: center;

    &__photo {
      height: 40px;
      margin-right: 16px;
    }

    .info-user {
      width: 150px;


      &__name {
        font-size: 13px;
        line-height: 16px;
        color: #111;

        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      &__id {
        margin-left: 5px;
        font-size: 13px;
        line-height: 16px;

        color: #8E8E93;
      }

      &__phone {
        font-size: 13px;
        line-height: 16px;
        color: #8c8c8c;

        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }

}


.right-panel {
  display: flex;
  align-items: center;
  justify-content: space-between;

}


.last-time {
  &__title {
    font-style: normal;
    font-weight: normal;
    font-size: 13px;
    line-height: 16px;

    color: #8E8E93;

  }

  &__date {
    display: flex;
    align-items: center;
    margin-top: 3px;

    font-style: normal;
    font-weight: normal;
    font-size: 13px;
    line-height: 16px;
    color: #111;

    &_time {
      display: flex;
      margin-left: 8px;

      font-size: 13px;
      line-height: 16px;

      color: #8E8E93;
    }
  }
}

.sing {
  text-align: center;
  width: 50px;
  margin-left: 25px;


}

</style>
